module.exports = __webpack_public_path__ + "img/store-allocation.825cde72.png";